import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { APP_STATUS } from 'src/constants/common'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { getSessionStatus } from 'src/store/slices/account'
import { RouteTracker } from 'src/components/analytics/RouteTracker'

import { Header } from './header'
import { Content, Layout } from './styled'
import { Footer } from './footer'

export const LayoutV2 = () => {
  const dispatch = useAppDispatch()
  const account = useAppSelector((state) => state.account)

  useEffect(() => {
    // Only check session status if it hasn't been checked yet
    if (account.getSessionStatus.status === APP_STATUS.INIT && !account.isLogin) {
      const checkSession = async () => {
        try {
          await dispatch(getSessionStatus())
        } catch (error) {
          // Session check failed - user is not authenticated
          console.log('Session check failed:', error)
        }
      }

      void checkSession()
    }
  }, [dispatch, account.getSessionStatus.status, account.isLogin])

  return (
    <Layout>
      <RouteTracker />
      <Content>
        <Header />
        <Outlet />
      </Content>
      <Footer />
    </Layout>
  )
}
